<div class="modal-info">
  <h1 class="modal-info__title">{{'OnlyForLoggedUsers' | translate}}</h1>
  <a class="modal-info__link"
  (click)="signin()">{{'Login' | translate}} / {{'Register' | translate}}</a>
</div>

